import styled from 'styled-components/macro';

export const LoaderWrapper = styled.div<{ padding?: string }>`
  margin: 0 auto;
  padding: ${({ padding, theme }) => padding || theme.spacing.one};
  border-radius: 8px;

  text-align: center;

  background-color: transparent;
`;

export const Loader = styled.svg`
  margin-bottom: ${({ theme }) => theme.spacing.one};
`;
